import { EventDispatcher } from "../event-dispatcher/EventDispatcher";
import AppContainer from "../AppContainer";

const initEventDispatcher = (eventDispatcher: EventDispatcher, appContainer: AppContainer): void => {
    const notificationDispatcher = appContainer.getNotificationDispatcher();
}
export default initEventDispatcher;